import { Country, State } from "./Geography";

// database field names
export type UserProfileJSON = {
  id?: null | number;
  first_name?: null | string;
  middle_name?: null | string;
  name_suffix?: null | string;
  last_name?: null | string;
  user_id?: null | number;
  address_one?: null | string;
  address_two?: null | string;
  city?: null | string;
  zip_code?: null | string;
  avatar?: null | string;
  email?: null | string; // *: actually stored in users table, but passed to api as if in users_profile
  countries_id?: null | string;
  states_id?: null | string; // sometimes set when account was initialized
  languages_id?: null | string; // *
  phone?: null | string; // *
  birthdate?: null | string,
  created_at?: null | number;
  updated_at?: null | number;
};

export class UserProfile {
  static path = "/user-profile";
  path = "/user-profile";

  constructor(
    public id?: null | number,
    public firstName?: null | string,
    public middleName?: null | string,
    public lastName?: null | string,
    public nameSuffix?: null | string,
    public userId?: null | number,
    public addressOne?: null | string,
    public addressTwo?: null | string,
    public city?: null | string,
    public zipCode?: null | string,
    public avatar?: null | string, // = "/static/images/avatars/avatar_6.png",
    public createdAt?: null | number,
    public updatedAt?: null | number,
    public countryId?: null | string,
    public stateId?: null | string,
    public languageId?: null | string,
    public phone?: null | string,
    public birthdate?: null | string,
  ) {
  }

  static fromJSON(json: UserProfileJSON): UserProfile {
    return new UserProfile(
      json.id,
      json.first_name,
      json.middle_name,
      json.last_name,
      json.name_suffix,
      json.user_id,
      json.address_one,
      json.address_two,
      json.city,
      json.zip_code,
      json.avatar,
      json.created_at,
      json.updated_at,
      json.countries_id,
      json.states_id,
      json.languages_id,
      json.phone,
      json.birthdate,
    );
  }

  toJSON(): UserProfileJSON {
    return {
      id: this.id,
      first_name: this.firstName,
      middle_name: this.middleName,
      last_name: this.lastName,
      name_suffix: this.nameSuffix,
      user_id: this.userId,
      address_one: this.addressOne,
      address_two: this.addressTwo,
      city: this.city,
      zip_code: this.zipCode,
      avatar: this.avatar,
      created_at: this.createdAt,
      updated_at: this.updatedAt,
      countries_id: this.countryId,
      states_id: this.stateId,
      languages_id: this.languageId,
      phone: this.phone,
      birthdate: this.birthdate,
    };
  }

  get fullName(): string | undefined {
    let retName = this.firstName;
    if (this.middleName) {
      retName += ` ${this.middleName}`;
    }
    if (this.lastName) {
      retName += ` ${this.lastName}`;
    }
    if (this.nameSuffix) {
      retName += `, ${this.nameSuffix}`;
    }
    return retName || undefined;
  }

  fullAddress(countries: Country[], states: State[]): string | undefined {
    if (!this.addressOne && !this.addressTwo && !this.city && !this.stateId && !this.countryId && !this.zipCode) {
      return undefined
    }

    let address = this.addressOne || ""
    if (this.addressTwo) {
      address += " " + this.addressTwo
    }
    address = address.trim()

    if (this.city) {
      address += ", " + this.city
    }

    let stateCode = ""
    if (this.stateId) {
      stateCode = states?.find(s => s.id.toString() == this.stateId)?.code?.toUpperCase() || ""
    }

    const stateAndZip = ((stateCode || "") + " " + (this.zipCode || "")).trim()
    if (stateAndZip) {
      address += ", " + stateAndZip
    }

    let countryCode = ""
    if (this.countryId) {
      countryCode = countries?.find(c => c.id.toString() == this.countryId)?.code?.toUpperCase() || ""
    }
    if (countryCode) {
      address += ", " + countryCode
    }

    return address
  }
}
